/** Timeline View Component
*/

'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var Tabs = require('src/behaviors/tabs')
var TabBehavior = require('src/behaviors/tabs')

// module.exports.layout = Marionette.View.extend({
//   template: require('./templates/layout.html'),
//   triggers: {
//   },
//   className: 'page page__client',
//   regions: {
//     headerRegion: '.header-region',
//     contentRegion: '.body-region',
//     tabLabels: '.nav-tabs'
//   },
//   behaviors: {
//     TabBehavior: {
//       behaviorClass: TabBehavior.Behavior,
//       tabsRegion: 'tabLabels'
//     }
//   },
//   onBeforeRender: function () {}
// })

var DialogBody = Marionette.View.extend({
  events: {
    'click .js-enable-group-edit': 'onEnableGroupEdit'
  },
  onRender: function () {
    let self = this

    // when this is a group or bulk edit, add enable
    // toggles around the inputs
    if (!self.options.model) {
      let inputs = this.el.querySelectorAll('.js-bulk-toggle-field')
      _.forEach(inputs, (input, index) => {
        self.wrapInputInGroupEdit(input, index)
      })
    }
  },
  wrapInputInGroupEdit: function (input, index) {
      // if input is already disabled don't give an option to enable it
    if (input.disabled) return
      // disable the input
    input.disabled = true

      // find if the input has a label
    let inputGroup = input.parentNode
    if (!inputGroup) return

    let wrap = document.createElement('div')
    wrap.className = 'form-group__group-edit-wrap js-group-edit-wrap'

    let bulkToggle = document.createElement('div')

    let bulkToggleCheckbox = document.createElement('input')
    bulkToggleCheckbox.type = 'checkbox'
    bulkToggleCheckbox.className = 'js-enable-group-edit group-edit-toggle'
    bulkToggleCheckbox.id = 'group-edit-toggle_' + index

    let bulkToggleLabel = document.createElement('label')
    bulkToggleLabel.htmlFor = 'group-edit-toggle_' + index

    wrap.appendChild(bulkToggleCheckbox)
    wrap.appendChild(bulkToggleLabel)

      // insert wrap after original element
    inputGroup.parentNode.insertBefore(wrap, inputGroup.nextSibling)

      // move input into wrap
    wrap.appendChild(inputGroup)
      // wrap the input in a div with an enable toggle
  },
  onEnableGroupEdit: function (ev) {
    var bulkToggle = ev.target
    var bulkGroup = bulkToggle.parentNode
    if (!bulkGroup) return

      // disable all inputs inside the bulk group
    let inputs = bulkGroup.querySelectorAll('input:not(.js-enable-group-edit), select:not(.js-enable-group-edit)')
    _.forEach(inputs, (input) => {
      input.disabled = !bulkToggle.checked
    })
    //  console.log(inputs)
  }
})

// ------------ //
var DialogLayout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  className: 'dialog',
  events: {
    'click .js-dialog-button': 'onButtonClick'
  },
  modelEvents: {
    'change': 'render'
  },
  initialize: function () {
    if (!this.options.dialogModel) return console.log('No dialogModel set...')
    // if the pagemodel has tabs, add them to the options so the tabs behavior can access them
    if (_.has(this.options.dialogModel.attributes, 'tabs')) {
      var tabs = []
      _.forEach(_.get(this.options.dialogModel.attributes, 'tabs'), function (tab) {
        tabs.push(new Tabs.Model(tab))
      })
      this.options.tabs = new Tabs.Collection(tabs)
    }
  },
  onButtonClick: function (ev) {
    if (!ev.currentTarget) return false
    var button = ev.currentTarget
    var action = button.getAttribute('data-action')
    this.trigger(action, this)
    // console.log(action)
  },
  getDialogTitle: function () {
    var title = ''
    if (this.model) {
      // console.log(_.get(this.options.dialogModel.attributes, 'automaticTitle'))
      if (_.get(this.options.dialogModel.attributes, 'automaticTitle')) {
        if (this.model.isNew()) {
          title = 'New '
        } else {
          title = 'Edit '
        }
      }

      // console.log(this.options.dialogModel.get('automaticTitle'))
      // console.log(this.model.get('automaticTitle'))
    } else if (this.collection) {
      if (_.get(this.options.dialogModel.attributes, 'automaticTitle')) {
        title = 'Bulk edit '
      } else {
        title = 'Bulk '
      }
    }
    var secondPart = _.get(this.options.dialogModel.attributes, 'title') || '&nbsp;'
    if (title) secondPart = secondPart.toLowerCase()
    return title + secondPart
  },
  regions: {
    headerRegion: '.dialog-header-region',
    bodyRegion: '.dialog-body-region',
    footerRegion: '.dialog-footer-region',
    tabsRegion: '.dialog-tabs-region'
  },
  behaviors: {
    Modal: {},
    TabBehavior: {
      behaviorClass: TabBehavior.Behavior,
      tabsRegion: 'tabsRegion',
      tabsContentContainer: '.js-tabs-container'
    }
  },
  templateContext: function () {
    var self = this
    return {
      getTitle: function () {
        return self.getDialogTitle()
      },
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getDialogModel: function () {
        return _.get(self.options, 'dialogModel.attributes')
      },
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel,
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }

})

module.exports.Layout = DialogLayout
module.exports.Body = DialogBody



// WEBPACK FOOTER //
// ./js/components/dialog-view/index.js